import React from 'react';
import { Table, Button } from 'antd';

import uuid from 'react-uuid';
import { withoutId } from '../../utils/data.js';
import CompoundSplitRowMenu from './CompoundSplitRowMenu.js';

function CompoundSplitMenu(props) {

  function toFixed(item) {
    if (item !== undefined) {
      return item.toFixed(2);
    }
  }

  function renderRemainder(item) {
    const fixed = toFixed(item);
    const color = item > 0.0000001 ? '#ff6961' : '#c1e1c1';
    return <strong style={{ color: color }}>{fixed}</strong>
  }

  function onPercentageChange(index, column, value) {
    if (!value) {
      value = 0;
    }

    const func = props.row.func;

    const newFunc = func.clone(func.id, func.target);
    newFunc.updated = true;
    newFunc.functions[index][column] = value;
    newFunc.functions[index].updated = true;

    const newSplitState = newFunc.getSplit();
    const newSplits = [...withoutId(props.model.splitState, newSplitState.id), newSplitState];
    props.setSplitsState(newSplits);
  }  

  const columns = [
    {
      title: 'Split',
      dataIndex: 'split',
      key: 'split',
      render: (item, record) => {
        return <CompoundSplitRowMenu
          item={item}
          record={record}
          row={props.row}
          model={props.model}
          setSplitsState={props.setSplitsState}
          onPercentageChange={onPercentageChange}/>
      }
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      render: (item) => toFixed(item)
    },
    {
      title: 'Sales',
      dataIndex: 'sales',
      key: 'sales',
      render: (item) => toFixed(item)
    },
    {
      title: 'PM',
      dataIndex: 'pm',
      key: 'pm',
      render: (item) => toFixed(item)
    },
    {
      title: 'Dir',
      dataIndex: 'dir',
      key: 'dir',
      render: (item) => toFixed(item)
    },
    {
      title: 'Remainder',
      dataIndex: 'remainder',
      key: 'remainder',
      render: (item) => renderRemainder(item)
    },
  ];

  const datasource = [];
  let sortOrder = 0;

  function push(item) {
    const id = uuid();
    Object.assign(item, { id, sortOrder });
    datasource.push(item);
    sortOrder++;
  }

  const account = props.model.accounts.find(a => a.id === props.row.accountId);

  push({
    split: '',
    row_type: 'header',
    sales: 0,
    pm: 0,
    dir: 0,
    total: account.amount,
    remainder: account.amount
  });

  const breakdown = props.row.func.getBreakdown(props.model);

  breakdown.forEach((result, index) => {
    push({
      split: '',
      split_type: result.func.type,
      row_type: 'subSplit',
      sales: result.sales,
      pm: result.pm,
      dir: result.dir,
      total: result.amount,
      remainder: result.remainder,
      model: props.model,
      func: result.func,
      index: index
    })
  });

  push({
    row_type: 'footer',
  });

  function back() {
    props.setMenuVisible(true);
    props.setCompoundSplitVisible(false);
  }


  return (
    <div>
      <Table dataSource={datasource}
             columns={columns}
             pagination={false}
      />
      <Button type="default"
        style={{
          marginTop: '20px',
          float: 'right',
          marginRight: '10px'
        }}
        onClick={back}>Back</Button>
    </div>
  );
}

export default CompoundSplitMenu;
